import Vue from 'vue'
import App from './App'
import router from './router'
import VueRouter from 'vue-router'
import { Toast } from 'mint-ui';
import { MessageBox } from 'mint-ui';
import { Indicator } from 'mint-ui';
import Axios from 'axios';
import qs from 'qs';
import 'lib-flexible/flexible.js'
import { Loadmore } from 'mint-ui';
import VueAwesomeSwiper from 'vue-awesome-swiper'
import '../static/css/swiper.css'
import '../static/css/index.css'
import AwesomePicker from './components/person/index.js'
import wxShare from './assets/js/share'
import echarts from 'echarts'
Vue.prototype.$echarts = echarts


Vue.use(AwesomePicker)
Vue.component(Loadmore.name, Loadmore);
Vue.prototype.wxShare = wxShare
Vue.prototype.$axios = Axios;
Vue.prototype.$qs = qs;
Axios.defaults.timeout = 20000; //请求超时时间
Axios.defaults.baseURL = 'https://api.efifan.com'
Axios.defaults.headers.post['Content-Type'] = 'application/json';
window.Toast = Toast;
window.MessageBox = MessageBox;
window.Indicator = Indicator;
Vue.use(VueRouter);

Vue.config.productionTip = false

Vue.use(VueAwesomeSwiper)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js